// financialYearActions.ts

import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  DeleteFinancialYearPayload,
  FinancialYearByIdPayload,
} from './financialYearTypes';
import authServiceApiInstance from '../../../config/apiConfig';

// Create financial year
export const createFinancialYear = createAsyncThunk(
  'financialYear/create',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await authServiceApiInstance.post('/financial-years', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create financial year');
    }
  }
);

// Get all financial years
export const fetchAllFinancialYears = createAsyncThunk(
  'financialYear/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await authServiceApiInstance.get('/financial-years');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch financial years');
    }
  }
);

// Get financial year by ID
export const fetchFinancialYearById = createAsyncThunk(
  'financialYear/fetchById',
  async ({ id }: FinancialYearByIdPayload, { rejectWithValue }) => {
    try {
      const response = await authServiceApiInstance.get(`/financial-years/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch financial year');
    }
  }
);

export const updateFinancialYear = createAsyncThunk(
  'financialYear/update',
  async ({ id, ...data }: any, { rejectWithValue }) => {
    try {
      const response = await authServiceApiInstance.put(`/financial-years/${id}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update financial year');
    }
  }
);

// Delete financial year
export const deleteFinancialYear = createAsyncThunk(
  'financialYear/delete',
  async ({ id }: DeleteFinancialYearPayload, { rejectWithValue }) => {
    try {
      await authServiceApiInstance.delete(`/financial-years/${id}`);
      return id;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete financial year');
    }
  }
);

export const fetchFinancialYearsByCompanyId = createAsyncThunk(
  'financialYear/fetchByCompanyId',
  async (companyId: number, { rejectWithValue }) => {
    try {
      const response = await authServiceApiInstance.get(`/financial-years/company/${companyId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch financial years by company');
    }
  }
);
